<template>
  <section class="app-footer">
    <div class="footer-main">
      <div class="top">
        <ul class="contact">
          <li v-for="(item, idx) in contactKeys" :key="idx">
            <label>{{ $t(`contact.${item}`) }}</label>
            <span>{{ contacts[item] }}</span>
          </li>
          <!-- <li class="app-store-li">
            <label>{{ $t('appLabel') }}</label>
            <div class="app-store">
              <app-store class="link" />
              <app-store app="android" class="link" />
            </div>
          </li> -->
        </ul>
      </div>
      <!-- <div class="bottom">
        <div class="disclaimers">
          <p class="text">{{ $t('disclaimers.text') }}</p>
          <p class="tips">{{ $t('disclaimers.tips') }}</p>
        </div>
      </div> -->
      
    </div>
    <div class="split" />
    <div class="copyright">
      <copyright />
      <a href="https://beian.miit.gov.cn" class="icp">{{ $t('icp', {icp}) }}</a>
    </div>
  </section>
</template>

<script>
import copyright from '@/components/common/copyright'
import config from '../../../../../static/config/config.js'
import appStore from '@/components/common/appStore'
export default {
  name: 'AppFooter',
  components: {
    copyright,
    appStore
  },
  computed: {
    icp() {
      return config.icp
    },
    contactKeys() {
      return Object.keys(this.contacts)
    },
    contacts() {
      return config.contact
    }
  }
}
</script>

<style lang="scss" scoped>
.app-footer {
  background: #1E1E20;
  padding: 10.6vw 0 2.6vw;
  .footer-main,
  .copyright {
    margin: 0 auto;
  }
  .split {
    height: 1px;
    background: #FFFFFF;
    opacity: 0.04;
    width: 100%;
  }
  .footer-main {
    padding: 0 4vw 8vw;
    .top {
      padding-bottom: 20.8vw;
      .contact {
        li {
          font-size: 3.7vw;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 5.3vw;
          margin-bottom: 2.6vw;
          display: flex;
          align-items: center;
          label {
            margin-right: 5.3vw;
            width: 16vw;
            display: inline-block;
          }
          .app-store {
            display: inline-block;
            .link {
              width: 9.3vw;
              height: 9.3vw;
              border-radius: 50%;
              border: 1px solid #FFFFFF;
              margin-right: 5.3vw;
              &:last-child {
                margin-right: 0;
              }
              .zr-icons {
                width: 100%;
                height: 100%;
              }
            }
          }
          &.app-store-li {
            padding-top: 2.6vw;
          }
        }
      }
    }
    .bottom {
      .disclaimers {
        .text {
          font-size: 3.2vw;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 5.3vw;
          margin-bottom: 2.6vw;
        }
        .tips {
          font-size: 3.2vw;
          font-weight: 400;
          color: #6D6C72;
          line-height: 4.2vw;
        }
      }
    }
    
  }
  .copyright {
    padding: 1.6vw 4vw 0;
    font-size: 2.6vw;
    font-weight: 400;
    color: #CFCFD4;
    line-height: 3.7vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>




// WEBPACK FOOTER //
// src/layout/components/h5/footer/index.vue